module.exports = __webpack_public_path__ + "static/img/PVC Film_semi_deskstop.553e8db5.jpg";